import { UPDATE_META } from './actions';

export const updateMeta = ( payload: any ) => ( {
  type: UPDATE_META,
  payload
} );
